/* Espace client maison : onglets connexion / inscription, mot de passe oublié, copie des codes promo,
   formulaires d'adresse, suivi maison (module « compte », via window.__ccq → cc-track.js). */
(function () {
  var root = document.querySelector('.cca');
  if (!root) return;
  var page = root.getAttribute('data-cca-page') || '';
  function T(action, cible, data) {
    try { (window.__ccq = window.__ccq || []).push(['compte', action, cible || page, Object.assign({ page: page }, data || {})]); } catch (e) {}
  }

  /* onglets connexion / inscription */
  var tabs = root.querySelectorAll('[data-cca-tab]');
  function show(name) {
    tabs.forEach(function (b) {
      var on = b.getAttribute('data-cca-tab') === name;
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      var p = document.getElementById(b.getAttribute('aria-controls'));
      if (p) p.hidden = !on;
    });
  }
  tabs.forEach(function (b) {
    b.addEventListener('click', function () { show(b.getAttribute('data-cca-tab')); T('onglet', b.getAttribute('data-cca-tab')); });
  });

  /* mot de passe oublié */
  var loginBox = root.querySelector('[data-cca-login]');
  var recBox = root.querySelector('[data-cca-recover-box]');
  function recover(on) {
    if (!loginBox || !recBox) return;
    loginBox.hidden = on; recBox.hidden = !on;
    if (on) { var i = recBox.querySelector('input[type=email]'); var e = root.querySelector('#cca-em'); if (i && e && e.value && !i.value) i.value = e.value; }
  }
  var r1 = root.querySelector('[data-cca-recover]');
  if (r1) r1.addEventListener('click', function () { recover(true); T('mot_de_passe_oublie'); });
  var r2 = root.querySelector('[data-cca-recover-back]');
  if (r2) r2.addEventListener('click', function () { recover(false); });
  if (location.hash === '#recover' || root.querySelector('[data-cca-recover-ok]')) { show('login'); recover(true); }

  /* copie d'un code promo */
  root.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-cca-copy]');
    if (!b) return;
    var code = b.getAttribute('data-cca-copy');
    function done() {
      b.textContent = 'Copié';
      clearTimeout(b._t); b._t = setTimeout(function () { b.textContent = 'Copier'; }, 2000);
    }
    function fallback() {
      var t = document.createElement('textarea'); t.value = code; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
      document.body.appendChild(t); t.select(); try { document.execCommand('copy'); } catch (e) {} document.body.removeChild(t); done();
    }
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(done, fallback); else fallback();
    T('copier_code', code);
  });

  /* liens suivis (facture, suivi colis, aide) */
  root.addEventListener('click', function (ev) {
    var a = ev.target.closest('[data-cca-t]');
    if (a) T(a.getAttribute('data-cca-t'), a.getAttribute('href'));
  });

  /* formulaires d'adresse : ouvrir / fermer, pays par défaut, suppression en deux temps */
  function open(id, on) {
    var f = document.getElementById(id); if (!f) return;
    f.hidden = !on;
    if (on) { f.scrollIntoView({ behavior: 'smooth', block: 'start' }); var i = f.querySelector('input:not([type=hidden])'); if (i) setTimeout(function () { i.focus({ preventScroll: true }); }, 300); }
  }
  root.querySelectorAll('[data-cca-open]').forEach(function (b) {
    b.addEventListener('click', function () { open(b.getAttribute('data-cca-open'), true); T('adresse_ouvrir', b.getAttribute('data-cca-open')); });
  });
  root.querySelectorAll('[data-cca-close]').forEach(function (b) {
    b.addEventListener('click', function () { open(b.getAttribute('data-cca-close'), false); });
  });
  root.querySelectorAll('.cca-form').forEach(function (f) { if (f.querySelector('.cca-err')) f.hidden = false; });
  root.querySelectorAll('select[data-cca-country]').forEach(function (s) {
    var v = s.getAttribute('data-cca-country');
    for (var k = 0; k < s.options.length; k++) { if (s.options[k].value === v || s.options[k].text === v) { s.selectedIndex = k; break; } }
  });
  root.querySelectorAll('form[data-cca-del]').forEach(function (f) {
    f.addEventListener('submit', function (ev) {
      var b = f.querySelector('button');
      if (!f._armed) { ev.preventDefault(); f._armed = true; b.textContent = 'Confirmer la suppression'; b.style.color = '#8A1C12'; return; }
      T('adresse_supprimer');
    });
  });
})();
